module.exports = __webpack_public_path__ + "img/canton.2a0ff3cb.jpg";